import { mixin as clickaway } from "vue-clickaway";

export default {
    name: "tooltip-layout",
    mixins: [clickaway],
    props: {
        position: {
            type: String,
            default: "left",
        },
        maxWidth: {
            type: Number,
            default: 200,
        },
    },
    data() {
        return {
            open: false,
        };
    },
    watch: {
        "$route.path"() {
            if (this.open) {
                this.close();
            }
        },
    },
    methods: {
        close() {
            this.open = false;
        },
    },
};
